<app-page-header></app-page-header>
<!-- Breadcromb Area Start -->
<app-breadcromb pageName="Job Categories"></app-breadcromb>
<!-- Breadcromb Area End -->


<!-- Top Job Area Start -->
<section class="jobguru-top-job-area browse-page section_70">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-3">
        <div class="job-grid-sidebar">

          <!-- Single Job Sidebar Start -->
          <!-- <div class="single-job-sidebar sidebar-category">
            <h3>Location</h3>
            <div class="job-sidebar-box">
              <form>
                <select class="sidebar-category-select-2" name="states[]">
                  <option >Choose Location</option>
                  <option value="1">Harare</option>
                  <option value="2">Bulawayo</option>
                  <option value="3">Mutare</option>
                  <option value="4">Masvingo</option>
                  <option value="5">Bindura</option>
                  <option value="6">Gweru</option>
                  <option value="7">Kwekwe</option>
                  <option value="7">Kariba</option>
                  <option value="7">Kadoma</option>
                  <option value="7">Chegutu</option>
                </select>
              </form>
            </div>
          </div> -->
          <!-- Single Job Sidebar End -->

          <!-- Single Job Sidebar Start -->
          <!-- <div class="single-job-sidebar sidebar-category">
            <h3>Category</h3>
            <div class="job-sidebar-box">
              <form>
                <select class="sidebar-category-select-2" name="states[]">
                  <option value="1">any category</option>
                  <option value="2">accounting/finance</option>
                  <option value="3">automotive jobs</option>
                  <option value="4">construction</option>
                  <option value="5">design, art & multimedia</option>
                  <option value="6">education training</option>
                  <option value="7">restaurent/food</option>
                  <option value="7">programming/tech</option>
                  <option value="7">sales/marketing</option>
                  <option value="7">data science/analysis</option>
                </select>
              </form>
            </div>
          </div> -->
          <!-- Single Job Sidebar End -->

          <!-- Single Job Sidebar Start -->
          <div class="single-job-sidebar sidebar-type">
            <h3>job type</h3>
            <div class="job-sidebar-box">
              <form   #usersForm="ngForm" (ngSubmit)="genericSearch(usersForm.value)">
                <ul>
                  <li class="checkbox" *ngFor="let job of jobTypes">
                    <!-- <input class="checkbox-spin" name="{{job.name}}" type="checkbox" id="{{job.name}}" ngModel (change)="onChange($event.target.value)"/> -->
                    <input class="checkbox-spin" name="{{job.name}}" type="checkbox" id="{{job.name}}" ngModel (change)="onChange($event.target.checked ? 'on' : 'off',job.id)"/>
                    <label for="{{job.name}}"><span></span>{{job.name}}</label>
                  </li>
                </ul>
              </form>
              <!-- <ul>
                <li class="checkbox">
                  <input class="checkbox-spin" type="checkbox" id="Full_Time" />
                  <label for="Full_Time"><span></span>Full Time</label>
                </li>
                <li class="checkbox">
                  <input class="checkbox-spin" type="checkbox" id="Internship" />
                  <label for="Internship"><span></span>Internship</label>
                </li>
                <li class="checkbox">
                  <input class="checkbox-spin" type="checkbox" id="Part_Time" />
                  <label for="Part_Time"><span></span>Graduate Trainee</label>
                </li>
                <li class="checkbox">
                  <input class="checkbox-spin" type="checkbox" id="Temporary" />
                  <label for="Temporary"><span></span>Temporary</label>
                </li>
              </ul> -->
            </div>
          </div>
          <!-- Single Job Sidebar End -->

        </div>
      </div>
      <div class="col-md-12 col-lg-9">
        <div class="job-grid-right">
          <div class="browse-job-head-option">
            <div class="job-browse-search">
              <form  #userForm="ngForm" (ngSubmit)="genericSearch(userForm.value)">
                <input required type="search" ngModel name="searchValue" placeholder="Search Jobs Here...">
                <button [disabled]="userForm.invalid" type="submit"><i class="fa fa-search"></i></button>
              </form>
            </div>
            <!-- <div class="job-browse-action">
              <div class="email-alerts">
                 <input type="checkbox" class="styled" id="b_1">
                 <label class="styled" for="b_1">email alerts for this search</label>
              </div>
              <div class="dropdown">
                <button class="btn-dropdown dropdown-toggle" type="button" id="dropdowncur" data-toggle="dropdown" aria-haspopup="true">Short By</button>
                <ul class="dropdown-menu" aria-labelledby="dropdowncur">
                  <li>Newest</li>
                  <li>Oldest</li>
                </ul>
              </div>
            </div> -->
          </div>
          <!-- end job head -->
          <div class="job-sidebar-list-single" >
            <!-- end sidebar single list -->
            <div *ngIf="!showVacancy" class="sidebar-list-single">
              <div class="top-company-list" >
                <div class="company-list-details">
                  <div class="row job-company-list" style="color: black!important;">
                    <div class="col-md-9">
                      <h3 style="font-size: 16px;"><b>There is no vacancy currently.</b></h3>
                    </div>
                    <!-- <div class="col-md-3"><strong>RefNo: </strong></div> -->
                  </div>
                  <!-- <p class="company-state"><i class="fa fa-map-marker"></i> </p>
                  <p class="company-state"><i class="fa fa-briefcase"></i> open position</p>
                  <p class="open-icon"><i class="fa fa-clock-o" id="cdate" ></i>Closing date :</p> -->
                </div>
                <!-- <div class="company-list-btn">
                  <a href="#" routerLink="" class="jobguru-btn">apply now</a>
                </div> -->
              </div>
            </div>
            <div  class="sidebar-list-single" *ngFor="let vacancy of vacancies">
              <div class="top-company-list" *ngIf="showVacancy" >
                <div class="company-list-details">
                  <div class="row job-company-list" style="color: black!important;">
                    <div class="col-md-9">
                      <h3 style="font-size: 16px;"><a routerLink="/job-details/{{vacancy.id}}"><b>{{vacancy.title}}</b></a></h3>
                    </div>
                    <div class="col-md-3"><strong>RefNo: {{vacancy.referenceNumber}}</strong></div>
                  </div>
                  <p class="company-state"><i class="fa fa-map-marker"></i> {{vacancy.location}}</p>
                  <p class="company-state"><i class="fa fa-briefcase"></i>{{vacancy.numberOfApplicants || 1}} open position</p>
                  <p class="open-icon"><i class="fa fa-clock-o" id="cdate" ></i>Closing date : {{vacancy.closingDate | date}}</p>
                </div>
                <div class="company-list-btn">
                  <a href="#" routerLink="/job-details/{{vacancy.id}}" class="jobguru-btn">apply now</a>
                </div>
              </div>
            </div>
          </div>
          <!-- end job sidebar list -->
          <!-- <div class="pagination-box-row">
            <p>Page 1 of 6</p>
            <ul class="pagination">
              <li class="active"><a href="#">1</a></li>
              <li><a href="#">2</a></li>
              <li><a href="#">3</a></li>
              <li>...</li>
              <li><a href="#">6</a></li>
              <li><a href="#"><i class="fa fa-angle-double-right"></i></a></li>
            </ul>
          </div> -->
          <!-- end pagination -->
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Top Job Area End -->
